module.exports = __webpack_public_path__ + "static/media/spritesheet.26237f40.png";